<template>
    <div class="vote">
        <van-search
            class="vote_search"
            v-model="keyWord"
            shape="round"
            placeholder="搜索"
            color= '#000'
            @input="voteSearch"
        />
        <div class="vote_list">
            <van-list
                class="votte_list_box"
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
            >
                <van-cell class="vote_list_card" @click="goQuestionnaireDetail(item.questionnaire_id)" v-for="item in list" :key="item.questionnaire_id" center :title="item.title" >
                    <template #right-icon>
                      <div class="search_icon_box">
                          <van-icon name="arrow" class="search_icon"/>
                      </div>
                    </template>
                    <template #label>
                      <!-- :label="item.createTime"  -->
                      <div class="vote_list_tag">
                        <div>{{item.createTime}}</div>
                        <van-tag v-if="item.is_done" type="success">已提交</van-tag>
                        <van-tag v-else type="warning">待填写</van-tag>
                      </div>
                    </template>
                </van-cell>
        </van-list>
        </div>
        <div v-if="is_vote_admin || mobile ==='18715124118'" class="analyse_icon" @click="goVoteResultList">
          <img src="./image/analyse.png">
        </div>
    </div>
</template>

<script>
import { get as getUser } from '../../../utils/token'
export default {
  data () {
    return {
      is_vote_admin: false, // 问卷分析页权限
      mobile: getUser('mobile'),
      list: [],
      loading: false,
      finished: false,
      keyWord: '', // 存储搜索关键字
      page: 1,
      size: 10
    }
  },
  activated () {
    if (this.$route.query.isUp && this.list.length > 0) {
      this.list = []
      this.page = 1
      this.keyWord = ''
      this.onLoad()
    }
  },
  methods: {
    upUvdata () {
      const user = getUser('user')
      this.$API.upUvData({
        user: user.id,
        path: '/exerland/questionnaireList',
        location: '问卷列表',
        tracking_type: 6
      })
    },
    // 关键字搜索
    voteSearch () {
      this.page = 1
      this.list = []
      this.onLoad()
    },
    // 跳转问卷分析列表
    goVoteResultList () {
      this.$router.push('/exerland/questionnaireResultList')
    },
    // 跳转问卷详情
    goQuestionnaireDetail (id) {
      this.$router.push({
        path: '/exerland/questionnaireDetail',
        query: {
          questionnaire_id: id
        }
      })
    },
    async onLoad () {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      this.loading = true
      const { page, size, mobile, keyWord } = this
      const data = await this.$API.getQuestionnaireResultList(page, size, mobile, keyWord, 0, 'open')
      if (data.code === 200) {
        this.list = this.list.concat(data.data.list)
        this.is_vote_admin = data.data.is_vote_admin
        this.page++
        if (+this.list.length >= +data.data.count) {
          this.finished = true
          this.loading = false
        } else {
          this.loading = false
        }
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.vote{
    width: 100%;
    height: 100%;
    .analyse_icon{
      width: 50px;
      height: 50px;
      background-color: #fff;
      position: absolute;
      border-radius: 50%;
      top: 85%;
      left: 80%;
      img{
        width: 50px;
        height: 50px;
        border-radius: 50%;
      }
    }
    // 此处不是最好的样式处理方案
    .van-search__content{
        background-color: #f2f8fc;
    }
    .vote_search{
        // width: 91.47%;
        margin: 0 auto;
    }
    .vote_list{
        width: 100%;
        height: 100%;
        overflow-y: scroll;
        background-color: #f2f8fc;
        margin: 0;
        padding: 20px 0;
        .vote_list_card:nth-child(1){
            margin-top: 0;
        }
        .vote_list_card{
            margin: 20px auto;
            width: 91.47%;
            height: 80px;
            border-radius: 14px;
            .vote_list_tag{
              width: 90%;
              display: flex;
              justify-content: space-between;
            }
            .search_icon_box{
              width: 25px;
              height: 25px;
              border-radius: 50%;
              text-align: center;
              box-shadow: -1px 2px 3px #888888;
            }
        }
    }
}
</style>
